/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberShiftStatus200, PostApiBarberShiftStatus400, PostApiBarberShiftStatus401, PostApiBarberShiftStatus403, PostApiBarberShiftStatus404, PostApiBarberShiftStatus500, PostApiBarberShiftStatusMutationRequest, PostApiBarberShiftStatusMutationResponse } from "../entities/PostApiBarberShiftStatus";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { modelsShiftStatusInputSchema } from "./models/shiftStatusInputSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const postApiBarberShiftStatus200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiBarberShiftStatus200>

/**
 * @description Bad Request
 */
export const postApiBarberShiftStatus400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStatus400>

/**
 * @description Unauthorized
 */
export const postApiBarberShiftStatus401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStatus401>

/**
 * @description Forbidden
 */
export const postApiBarberShiftStatus403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStatus403>

/**
 * @description Not Found
 */
export const postApiBarberShiftStatus404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStatus404>

/**
 * @description Internal Server Error
 */
export const postApiBarberShiftStatus500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStatus500>

/**
 * @description Статус (free/busy/break)
 */
export const postApiBarberShiftStatusMutationRequestSchema = z.lazy(() => modelsShiftStatusInputSchema) as unknown as z.ZodType<PostApiBarberShiftStatusMutationRequest>

export const postApiBarberShiftStatusMutationResponseSchema = z.lazy(() => postApiBarberShiftStatus200Schema) as unknown as z.ZodType<PostApiBarberShiftStatusMutationResponse>